import { Component, OnInit, Input, Output, EventEmitter, AfterContentInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { RequestModel } from '@models/request.model';
import { ReviewModel } from '@models/review.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpApiService } from '@services/http-api.service';
import { GOOGLE_REPLY_CHARACTERS, FACEBOOK_REPLY_CHARACTERS } from '@utilities/const-utils';
import { isFacebook, isGoogle, isReviewFromFacebook, isReviewFromGMB } from '@utilities/function-utils';
import { map, NEVER, Subscription } from 'rxjs';
import { GenerateReplyComponent } from '../generate-reply/generate-reply.component';
import Swal from 'sweetalert2';
import { ResellersFacadeService } from '@services/resellers/resellers-facade.service';
import { UpgradeFeatureModalComponent } from '../upgrade-feature-modal/upgrade-feature-modal.component';
import { ResellerModel } from '@models/reseller.model';
import { LocationsFacadeService } from '@services/locations/locations-facade.service';
import { UpgradeAction } from '@models/upgradePlan.model';


@Component({
  selector: 'reply-to-review',
  templateUrl: './reply-to-review.component.html',
  styleUrls: ['./reply-to-review.component.sass']
})
export class ReplyToReviewComponent implements OnInit, AfterContentInit, OnDestroy {
  @Input() review: ReviewModel;
  @Input() locationName: String;
  @Input() currentResponse: string;
  @Input() reviewTargetName: string;
  @Input() isEnableOpenai: boolean = false;
  @Output() post = new EventEmitter<string>();
  @Output() cancel = new EventEmitter();

  replyToReviewForm: FormGroup;
  replyCharacters;
  _subs: Subscription = NEVER.subscribe()
  showPostBtn: boolean = false
  currentReseller$ = this.resellerService.getSelectedReseller$();
  currentReseller: ResellerModel;

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private httpApiService: HttpApiService,
    private resellerService: ResellersFacadeService,
    private locationsFacadeService: LocationsFacadeService,
  ) { }

  ngOnInit() {
    if (isGoogle(this.reviewTargetName)) {
      this.replyCharacters = GOOGLE_REPLY_CHARACTERS
    }
    else if (isFacebook(this.reviewTargetName)) {
      this.replyCharacters = FACEBOOK_REPLY_CHARACTERS
    }
    else {
      this.replyCharacters = 500
    }
    this.showPostBtn = this.showReplyButton(this.review)
  }

  ngAfterContentInit(): void {
    this.replyToReviewForm = this.fb.group({
      response: [this.currentResponse, Validators.compose([
        Validators.required,
        Validators.pattern(/.*\S.*/),
        Validators.maxLength(this.replyCharacters)]
      )]
    })
    this._subs.add(
      this.currentReseller$
        .subscribe(item => this.currentReseller = item)
    )
  }

  copyResponse() {
    const textarea = document.getElementById('response') as HTMLTextAreaElement;
    textarea.select();
    document.execCommand('copy');
  }

  openGenerateReplyModal() {
    const modalRef = this.modalService.open(GenerateReplyComponent, { centered: true, backdrop: 'static', keyboard: false });
  }
  generateReply() {
    console.log(this.review);

    const request: RequestModel = {
      params: `reviews/reply-generate-response`,
      payload: {
        locationId: this.review.locationId,
        reviewerName: this.review.userName,
        locationName: this.locationName,
        reviewMessage: this.review.message,
        reviewSite: this.review.reviewSiteName,
        startRating: this.review.rating
      }
    }
    this._subs.add(
      this.httpApiService.postRequest(request)
        .pipe(
          map(item => item["text"]),
          map(text => text.replace(/\n/g, "")),
        )
        .subscribe({
          next: text => {
            this.currentResponse = text
            this.replyToReviewForm.patchValue({
              response: this.currentResponse
            })
          },
          error: (error) => {
            this.launchAlertMssg('Reply Limit Reached', error.error.message, 'error');
          }
        }))

  }
  generateReplyIfValidate() {
    if (this.isEnableOpenai) {
      this.generateReply()
    } else {
      if (this.currentReseller.enabledUpgradeModal) {
        this.openUpgradeFeatureModal()
      }
      else {
        this.showModalInfo()
      }
    }
  }
  /**
 * Function that Evaluates if Reply button can be shown
 * based on  {@link ReviewModel} name property. 
 * If the name contains "Google" or "Facebook" the funtion
 * returns true and otherwise false.
 * @param review An object that contains the review
 */
  showReplyButton(review: ReviewModel) {
    return isGoogle(review.reviewSiteName) || isFacebook(review.reviewSiteName)
  }
  launchAlertMssg(title: string, message: string, type: any) {
    Swal.fire({
      title: title,
      html: message,
      icon: type,
      showCancelButton: false,
      confirmButtonText: 'OK'
    })
  }
  showModalInfo() {
    Swal.fire({
      title: 'Upgrade to Add AI-Review Replies',
      text: 'To add AI-Review Replies feature to your plan, contact Support',
      icon: 'info',
      showCancelButton: false,
      confirmButtonText: 'Ok!'
    })
  }
  openUpgradeFeatureModal() {
    const modalRef = this.modalService.open(UpgradeFeatureModalComponent, { centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.title = "Upgrade to Add AI-Review Replies";
    modalRef.componentInstance.bodyText = "Learn more about this feature";
    modalRef.componentInstance.bodyTextLink = "https://help.getmorereviews.com/en/articles/9071974-using-ai-powered-review-replies";
    //subscribe to child output event
    this._subs.add(
      modalRef.componentInstance.addOnEmit
        .subscribe(val => {
          this.locationsFacadeService.upgradePlan({ action: UpgradeAction.OPEN_AI, cancelFeatureButton: "" })
        })
    )
    this._subs.add(
      modalRef.componentInstance.upgradePlanEmit
        .subscribe(val => {
          this.locationsFacadeService.upgradePlan({ action: UpgradeAction.UPGRADE_ALL, cancelFeatureButton: "" })
        })
    )
    this._subs.add(
      modalRef.componentInstance.cancelEmit
        .subscribe(val => {
          this.locationsFacadeService.upgradePlan({ action: UpgradeAction.CANCEL, cancelFeatureButton: "AI-Review Replies" })
        })
    )

  }
  ngOnDestroy(): void {
    if (this._subs) this._subs.unsubscribe()
  }
}